import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';

export default function SupportPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-8 bg-gradient-to-br from-[#f5f3f0] via-white to-white">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-2 h-2 bg-[#1a2332] rotate-45"></div>
            <span className="text-sm font-medium text-[#1a2332] uppercase tracking-wider">Support Policy</span>
          </div>
          <h1 className="text-5xl font-bold text-[#1a2332] mb-6">サポートについて</h1>
          <p className="text-xl text-[#4a5568] leading-relaxed">
            Trim-Pageは「公開して終わり」ではなく、必要なときだけ利用できるスポット型サポートを基本としています。月額契約を前提とせず、無駄な固定費を発生させない支援方針を採用しています。
          </p>
        </div>
      </section>

      {/* 無償サポート Section */}
      <section id="free-support" className="py-32 px-8 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-[#1a2332] rounded-full">
                <i className="ri-gift-line text-2xl text-white"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#2d3748]">無償サポート（公開後1か月）</h2>
            </div>
          </div>

          <div className="space-y-8">
            {/* 対象期間 */}
            <div className="bg-[#f5f3f0] p-8 rounded-xl">
              <h3 className="text-xl font-bold text-[#2d3748] mb-4 flex items-center gap-2">
                <i className="ri-calendar-check-line text-[#1a2332]"></i>
                対象期間
              </h3>
              <p className="text-[#4a5568] text-lg">サイト公開日から1か月間</p>
            </div>

            {/* 対象内容 */}
            <div className="bg-white border border-[#e2e8f0] p-8 rounded-xl">
              <h3 className="text-xl font-bold text-[#2d3748] mb-6 flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-[#1a2332]"></i>
                対象内容
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {['表示崩れ', 'リンク不備', '動作不良', '明確な実装ミス'].map((item, index) => (
                  <div key={index} className="flex items-center gap-3 p-4 bg-[#f5f3f0] rounded-lg">
                    <i className="ri-check-line text-xl text-[#1a2332]"></i>
                    <span className="text-[#4a5568] font-medium">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* 不具合の定義 */}
            <div className="bg-[#fff8e1] border-l-4 border-[#d97706] p-8 rounded-lg">
              <h3 className="text-xl font-bold text-[#2d3748] mb-4 flex items-center gap-2">
                <i className="ri-alert-line text-[#d97706]"></i>
                不具合の定義（重要）
              </h3>
              <p className="text-[#4a5568] mb-6 text-lg">
                <strong className="text-[#2d3748]">不具合 = 仕様通りに動作しないもの</strong>
              </p>
              <p className="text-[#4a5568] mb-4">以下は不具合には含まれません：</p>
              <ul className="space-y-2">
                {['デザインの好み', '文言変更', '構成変更', '追加要望'].map((item, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <i className="ri-close-line text-[#d97706] mt-1"></i>
                    <span className="text-[#4a5568]">{item}</span>
                  </li>
                ))}
              </ul>
              <p className="text-sm text-[#4a5568] mt-4 bg-white/50 p-3 rounded">
                これらは「仕様変更」として扱います。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 有償サポート Section */}
      <section id="paid-support" className="py-32 px-8 bg-[#fafafa]">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-[#1a2332] rounded-full">
                <i className="ri-hand-coin-line text-2xl text-white"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#2d3748]">有償サポート（2か月目以降）</h2>
            </div>
            <p className="text-lg text-[#4a5568]">必要なときのみご依頼いただく形式です。</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* スポット相談 */}
            <div className="bg-white border border-[#e2e8f0] rounded-xl overflow-hidden">
              <div className="bg-[#1a2332] p-6">
                <h3 className="text-2xl font-bold text-white mb-2">スポット相談</h3>
                <div className="text-4xl font-bold text-white" style={{ fontFamily: 'Georgia, serif' }}>
                  ¥2,000<span className="text-lg font-normal">/時間</span>
                </div>
              </div>
              <div className="p-6">
                <p className="text-sm text-[#4a5568] mb-4">※ 作業は含まれません</p>
                <h4 className="font-bold text-[#2d3748] mb-3">対応例：</h4>
                <ul className="space-y-2">
                  {['更新方法の相談', 'ドメイン関連の相談', 'CMS運用相談', '技術的な確認'].map((item, index) => (
                    <li key={index} className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-[#1a2332] mt-0.5"></i>
                      <span className="text-sm text-[#4a5568]">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* 修正・変更作業 */}
            <div className="bg-white border border-[#e2e8f0] rounded-xl overflow-hidden">
              <div className="bg-[#1a2332] p-6">
                <h3 className="text-2xl font-bold text-white mb-2">修正・変更作業</h3>
                <div className="text-4xl font-bold text-white" style={{ fontFamily: 'Georgia, serif' }}>
                  ¥5,000<span className="text-lg font-normal">〜</span>
                </div>
              </div>
              <div className="p-6">
                <p className="text-sm text-[#4a5568] mb-4">作業規模・影響範囲により個別見積となります。</p>
                <h4 className="font-bold text-[#2d3748] mb-3">対応例：</h4>
                <ul className="space-y-2">
                  {['文言修正', 'セクション追加', 'レイアウト調整', 'ページ追加', 'CMS連携調整'].map((item, index) => (
                    <li key={index} className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-[#1a2332] mt-0.5"></i>
                      <span className="text-sm text-[#4a5568]">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* サポート対象外 Section */}
      <section id="out-of-scope" className="py-32 px-8 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-[#d97706] rounded-full">
                <i className="ri-error-warning-line text-2xl text-white"></i>
              </div>
              <h2 className="text-4xl font-bold text-[#2d3748]">サポート対象外</h2>
            </div>
            <p className="text-lg text-[#4a5568]">以下は原則対象外となります。</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              '大規模仕様変更',
              'サイト全面改修',
              '第三者サービス障害',
              '緊急対応保証',
              'SEO順位保証',
              '売上保証'
            ].map((item, index) => (
              <div key={index} className="flex items-center gap-3 p-4 bg-[#f5f3f0] border border-[#e2e8f0] rounded-lg">
                <i className="ri-close-circle-line text-xl text-[#d97706]"></i>
                <span className="text-[#4a5568] font-medium">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ドメイン・インフラ Section */}
      <section id="domain-infra" className="py-32 px-8 bg-[#fafafa]">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <h2 className="text-4xl font-bold text-[#2d3748] mb-4">ドメイン・インフラ関連の責任範囲</h2>
          </div>

          <div className="space-y-8">
            {/* 基本原則 */}
            <div className="bg-white border border-[#e2e8f0] p-8 rounded-xl">
              <h3 className="text-xl font-bold text-[#2d3748] mb-6 flex items-center gap-2">
                <i className="ri-shield-check-line text-[#1a2332]"></i>
                基本原則
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#f5f3f0] rounded-full flex-shrink-0">
                    <i className="ri-user-line text-[#1a2332]"></i>
                  </div>
                  <div>
                    <p className="font-bold text-[#2d3748] mb-1">契約主体</p>
                    <p className="text-[#4a5568]">お客様</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#f5f3f0] rounded-full flex-shrink-0">
                    <i className="ri-refresh-line text-[#1a2332]"></i>
                  </div>
                  <div>
                    <p className="font-bold text-[#2d3748] mb-1">更新責任</p>
                    <p className="text-[#4a5568]">お客様</p>
                  </div>
                </div>
              </div>
              <p className="text-sm text-[#4a5568] mt-6 bg-[#f5f3f0] p-4 rounded-lg">
                当方は管理権限を持ちません。
              </p>
            </div>

            {/* ドメイン更新代行プラン */}
            <div className="bg-[#f5f3f0] p-8 rounded-xl">
              <h3 className="text-xl font-bold text-[#2d3748] mb-6 flex items-center gap-2">
                <i className="ri-service-line text-[#1a2332]"></i>
                ドメイン更新代行プラン契約時
              </h3>
              <ul className="space-y-3">
                {[
                  '更新作業を代行',
                  '実費は別途',
                  '失効防止のための連絡フローを事前設定'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-check-line text-xl text-[#1a2332] mt-0.5"></i>
                    <span className="text-[#4a5568]">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 外部サービス Section */}
      <section id="external-services" className="py-32 px-8 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <h2 className="text-4xl font-bold text-[#2d3748] mb-4">外部サービスについて</h2>
            <p className="text-lg text-[#4a5568]">
              Trim-Pageは外部サービス（Cloudflare / GitHub / microCMS 等）を利用します。
            </p>
          </div>

          <div className="bg-[#fff8e1] border-l-4 border-[#d97706] p-8 rounded-lg">
            <p className="text-[#4a5568] mb-4">そのため、以下について保証は行いません：</p>
            <ul className="space-y-3 mb-6">
              {['サービス仕様変更', '障害', '利用制限'].map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-alert-line text-[#d97706] mt-0.5"></i>
                  <span className="text-[#4a5568]">{item}</span>
                </li>
              ))}
            </ul>
            <p className="text-[#2d3748] font-bold bg-white/50 p-4 rounded">
              各サービスの契約・管理責任はお客様に帰属します。
            </p>
          </div>
        </div>
      </section>

      {/* 技術的な注意事項 Section */}
      <section id="technical-notes" className="py-32 px-8 bg-[#fafafa]">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white border border-[#e2e8f0] p-10 rounded-xl">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-[#1a2332] rounded-full flex-shrink-0">
                <i className="ri-code-s-slash-line text-2xl text-white"></i>
              </div>
              <div>
                <h2 className="text-3xl font-bold text-[#2d3748] mb-4">技術的な注意事項</h2>
                <p className="text-[#4a5568] leading-relaxed">
                  静的サイト構成のため、HTML / CSS / JavaScript やビルド環境の理解が必要な場合があります。自己修正をご希望の場合は事前にご相談ください。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* サポート依頼の流れ Section */}
      <section id="support-flow" className="py-32 px-8 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#2d3748] mb-4">サポート依頼の流れ</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
            {[
              { step: '01', icon: 'ri-mail-send-line', title: 'お問い合わせ' },
              { step: '02', icon: 'ri-search-eye-line', title: '内容確認' },
              { step: '03', icon: 'ri-checkbox-circle-line', title: '対応可否判断' },
              { step: '04', icon: 'ri-file-list-3-line', title: '見積提示' },
              { step: '05', icon: 'ri-tools-line', title: '作業実施' }
            ].map((item, index) => (
              <div key={index} className="relative">
                <div className="text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-[#1a2332] rounded-full mb-4">
                    <i className={`${item.icon} text-2xl text-white`}></i>
                  </div>
                  <div className="mb-2">
                    <span className="inline-block px-3 py-1 bg-[#f5f3f0] rounded-full text-xs font-bold text-[#1a2332]">
                      STEP {item.step}
                    </span>
                  </div>
                  <h3 className="text-sm font-bold text-[#2d3748]">{item.title}</h3>
                </div>
                {index < 4 && (
                  <div className="hidden md:block absolute top-8 -right-3 text-[#e2e8f0]">
                    <i className="ri-arrow-right-line text-2xl"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 対応時間・レスポンス Section */}
      <section id="response-time" className="py-32 px-8 bg-[#fafafa]">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white border border-[#e2e8f0] p-10 rounded-xl">
            <h2 className="text-3xl font-bold text-[#2d3748] mb-8">対応時間・レスポンス</h2>
            <div className="space-y-4">
              {[
                { icon: 'ri-time-line', text: '営業時間内での対応' },
                { icon: 'ri-timer-line', text: '即時対応保証なし' },
                { icon: 'ri-question-line', text: '内容により回答に時間を要する場合あり' }
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-4 p-4 bg-[#f5f3f0] rounded-lg">
                  <div className="w-10 h-10 flex items-center justify-center bg-white rounded-full flex-shrink-0">
                    <i className={`${item.icon} text-xl text-[#1a2332]`}></i>
                  </div>
                  <p className="text-[#4a5568] pt-2">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 免責事項 Section */}
      <section id="disclaimer" className="py-32 px-8 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="bg-[#fff8e1] border-l-4 border-[#d97706] p-10 rounded-lg">
            <h2 className="text-3xl font-bold text-[#2d3748] mb-8 flex items-center gap-3">
              <i className="ri-alert-line text-[#d97706]"></i>
              免責事項
            </h2>
            <ul className="space-y-4">
              {[
                '結果保証なし',
                '第三者要因責任なし',
                'データ保全責任なし（バックアップ推奨）'
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <i className="ri-close-circle-line text-xl text-[#d97706] mt-0.5"></i>
                  <span className="text-[#4a5568] text-lg">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-32 px-8 bg-[#fafafa]">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#2d3748] mb-4">よくある質問（FAQ）</h2>
          </div>

          <div className="space-y-4">
            {[
              {
                question: '軽微な修正でも有償になりますか？',
                answer: '期間外の場合は原則有償となります。'
              },
              {
                question: '急ぎ対応は可能ですか？',
                answer: '可能な場合もありますが保証はできません。'
              },
              {
                question: '他社制作サイトも対応できますか？',
                answer: '内容・構造により応相談となります。'
              },
              {
                question: 'CMSやサーバー障害は対応できますか？',
                answer: '原則として各サービス提供元へご確認ください。'
              }
            ].map((faq, index) => (
              <div key={index} className="bg-white border border-[#e2e8f0] rounded-lg overflow-hidden">
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full px-8 py-6 flex items-center justify-between hover:bg-[#f5f3f0] transition-colors cursor-pointer"
                  style={{ backgroundColor: openFaq === index ? '#f5f3f0' : 'transparent' }}
                >
                  <div className="flex items-center gap-4">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#1a2332] rounded-full flex-shrink-0">
                      <span className="text-white font-bold text-sm">Q</span>
                    </div>
                    <span className="font-bold text-[#2d3748] text-left">{faq.question}</span>
                  </div>
                  <i className={`ri-arrow-${openFaq === index ? 'up' : 'down'}-s-line text-2xl text-[#2d3748] flex-shrink-0`}></i>
                </button>
                {openFaq === index && (
                  <div className="px-8 py-6 bg-[#f5f3f0]">
                    <p className="text-[#4a5568] leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 px-8 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-gradient-to-br from-[#1a2332] to-[#2d3748] p-12 rounded-2xl text-white">
            <h2 className="text-4xl font-bold mb-6">サポートのご相談はこちら</h2>
            <p className="text-xl mb-8 text-white/90">
              お問い合わせフォームよりご連絡ください。<br />
              現象・ご希望内容をできるだけ具体的にご記載ください。
            </p>
            <Link
              to="/"
              onClick={(e) => {
                e.preventDefault();
                window.REACT_APP_NAVIGATE('/');
                setTimeout(() => {
                  const element = document.getElementById('contact');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }, 100);
              }}
              className="inline-block px-10 py-4 bg-white text-[#1a2332] rounded-full font-medium hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              お問い合わせフォームへ
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a2332] text-white py-20 px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            {/* Left Column */}
            <div className="md:col-span-1">
              <div className="flex items-center gap-3 mb-6">
                <img 
                  src="https://public.readdy.ai/ai/img_res/4944a4ba-c62a-4964-bf85-4ed6714cc305.png" 
                  alt="Trim-Page Logo" 
                  className="w-10 h-10 object-contain"
                />
                <h3 className="text-3xl font-bold">Trim-Page</h3>
              </div>
              <p className="text-white/80 leading-relaxed mb-6">
                小規模店舗・個人事業主のための、月額費用のない静的サイト制作サービス
              </p>
              <div className="flex gap-4">
                {['ri-twitter-x-line', 'ri-facebook-circle-line', 'ri-instagram-line', 'ri-linkedin-box-line'].map((icon, index) => (
                  <a
                    key={index}
                    href="#"
                    className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full hover:bg-white/10 transition-colors cursor-pointer"
                  >
                    <i className={`${icon} text-lg`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Middle Column */}
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider mb-6">Contact</h4>
              <div className="space-y-4">
                <div>
                  <p className="text-sm text-white/60 mb-1">メールアドレス</p>
                  <a href="mailto:info@trim-page.com" className="text-white hover:text-white/80 transition-colors">
                    info@trim-page.com
                  </a>
                </div>
                <div>
                  <Link
                    to="/"
                    onClick={(e) => {
                      e.preventDefault();
                      window.REACT_APP_NAVIGATE('/');
                      setTimeout(() => {
                        const element = document.getElementById('contact');
                        if (element) {
                          element.scrollIntoView({ behavior: 'smooth' });
                        }
                      }, 100);
                    }}
                    className="text-white underline hover:text-white/80 transition-colors cursor-pointer"
                  >
                    お問い合わせフォーム
                  </Link>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div>
              <h4 className="text-sm font-bold uppercase tracking-wider mb-6">Information</h4>
              <div className="space-y-4">
                <Link to="/about-operator" className="block text-white hover:text-white/80 transition-colors">
                  運営者情報
                </Link>
                <Link to="/tokushoho" className="block text-white hover:text-white/80 transition-colors">
                  特定商取引法に基づく表記
                </Link>
                <Link to="/privacy-policy" className="block text-white hover:text-white/80 transition-colors">
                  プライバシーポリシー
                </Link>
                <Link to="/support" className="block text-white hover:text-white/80 transition-colors">
                  サポートについて
                </Link>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/60">© 2025 Trim-Page. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="text-sm text-white/60 hover:text-white transition-colors">
                利用規約
              </a>
              <a href="#" className="text-sm text-white/60 hover:text-white transition-colors">
                サイトマップ
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-sm text-white/60 hover:text-white transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
